// // // import React from 'react';
// // // import { X, Star, Calendar, User, Mail, Phone, MessageCircle } from 'lucide-react';

// // // export default function BookingPopup({ expert, onClose, onSubmit }) {
// // //   const handleSubmit = (e) => {
// // //     e.preventDefault();
// // //     onSubmit(expert);
// // //   };

// // //   return (
// // //     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
// // //       {/* Modal container - relative positioning for absolute close button */}
// // //       <div style={{ scrollbarWidth:"none"}} className="relative bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
// // //         {/* Close button - positioned absolutely within the modal */}
// // //         <button
// // //           onClick={onClose}
// // //           className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition z-10 bg-white rounded-full p-1 shadow-sm hover:shadow-md"
// // //         >
// // //           <X size={22} />
// // //         </button>

// // //         {/* Header */}
// // //         <div className="p-6 border-b border-gray-100">
// // //           <div className="flex items-center gap-4">
// // //             <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xl font-bold flex items-center justify-center shrink-0">
// // //               {expert.initials}
// // //             </div>
// // //             <div>
// // //               <h3 className="font-bold text-gray-900 text-lg">{expert.name}</h3>
// // //               <p className="text-sm text-gray-500">{expert.specialty}</p>
// // //               <div className="flex items-center gap-1 mt-0.5">
// // //                 <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
// // //                 <span className="text-sm font-medium text-gray-700">{expert.rating}</span>
// // //                 <span className="text-xs text-gray-400">({expert.institution})</span>
// // //               </div>
// // //             </div>

// // //           </div>
// // //           <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
// // //             <span className="text-sm text-gray-500">Consultation Fee</span>
// // //             <span className="font-semibold text-indigo-600">₹{expert.rate.toLocaleString("en-IN")}/session</span>
// // //           </div>
// // //         </div>

// // //         {/* Form */}
// // //         <form className="p-6 space-y-4" onSubmit={handleSubmit}>
// // //           <div>
// // //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// // //               <User size={16} />
// // //               Full Name
// // //             </label>
// // //             <input
// // //               type="text"
// // //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// // //               placeholder="Enter your full name"
// // //               required
// // //             />
// // //           </div>

// // //           <div>
// // //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// // //               <Mail size={16} />
// // //               Email Address
// // //             </label>
// // //             <input
// // //               type="email"
// // //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// // //               placeholder="Enter your email"
// // //               required
// // //             />
// // //           </div>

// // //           <div>
// // //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// // //               <Phone size={16} />
// // //               Phone Number
// // //             </label>
// // //             <input
// // //               type="tel"
// // //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// // //               placeholder="Enter your phone number"
// // //               required
// // //             />
// // //           </div>

// // //           <div>
// // //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// // //               <Calendar size={16} />
// // //               Preferred Date & Time
// // //             </label>
// // //             <input
// // //               type="datetime-local"
// // //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// // //               required
// // //             />
// // //           </div>

// // //           <div>
// // //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// // //               <MessageCircle size={16} />
// // //               Message (Optional)
// // //             </label>
// // //             <textarea
// // //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
// // //               placeholder="Briefly describe what you need help with..."
// // //               rows="3"
// // //             />
// // //           </div>

// // //           <button
// // //             type="submit"
// // //             className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-600 hover:opacity-90 text-white font-semibold py-3 rounded-xl transition"
// // //           >
// // //             <Calendar size={18} />
// // //             Confirm Booking
// // //           </button>
// // //         </form>
// // //       </div>
// // //     </div>
// // //   );
// // // }



// // import React, { useState } from 'react';
// // import { X, Star, Calendar, User, Mail, Phone, MessageCircle, Loader2 } from 'lucide-react';
// // import { useToast } from '../../../../context/ToastContext';

// // export default function BookingPopup({ expert, onClose, onSubmit }) {
// //   const [fullName, setFullName] = useState('');
// //   const [email, setEmail] = useState('');
// //   const [phone, setPhone] = useState('');
// //   const [bookingDate, setBookingDate] = useState('');
// //   const [bookingTime, setBookingTime] = useState('');
// //   const [durationMinutes, setDurationMinutes] = useState(30);
// //   const [message, setMessage] = useState('');
// //   const [loading, setLoading] = useState(false);

// //   const userId = localStorage.getItem('userId');

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);

// //     // ✅ Format time as "HH:MM:SS" string
// //     const formattedTime = bookingTime ? `${bookingTime}:00` : "00:00:00";

// //     const bookingData = {
// //       userId: parseInt(userId) || 0,
// //       expertId: expert.id || expert.expertId,
// //       fullName: fullName,
// //       email: email,
// //       phone: phone,
// //       bookingDate: bookingDate,
// //       bookingTime: formattedTime, // ✅ Send as string "HH:MM:SS"
// //       durationMinutes: durationMinutes,
// //       message: message || "",
// //       consultationFee: expert.price || expert.rate || 0,
// //       razorpayOrderId: "order_test_" + Date.now(),
// //       razorpayPaymentId: "pay_test_" + Date.now(),
// //       razorpaySignature: "test_signature_" + Date.now(),
// //     };

// //     await onSubmit(bookingData);
// //     setLoading(false);
// //   };

// //   return (
// //     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
// //       <div style={{ scrollbarWidth: "none" }} className="relative bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
// //         <button
// //           onClick={onClose}
// //           className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition z-10 bg-white rounded-full p-1 shadow-sm hover:shadow-md"
// //         >
// //           <X size={22} />
// //         </button>

// //         {/* Header */}
// //         <div className="p-6 border-b border-gray-100">
// //           <div className="flex items-center gap-4">
// //             <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xl font-bold flex items-center justify-center shrink-0">
// //               {expert.mentorName ? expert.mentorName.charAt(0).toUpperCase() : expert.initials}
// //             </div>
// //             <div>
// //               <h3 className="font-bold text-gray-900 text-lg">{expert.mentorName || expert.name}</h3>
// //               <p className="text-sm text-gray-500">{expert.expertise || expert.specialty}</p>
// //               <div className="flex items-center gap-1 mt-0.5">
// //                 <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
// //                 <span className="text-sm font-medium text-gray-700">{expert.rating || 0}</span>
// //                 <span className="text-xs text-gray-400">({expert.institution || 'Expert'})</span>
// //               </div>
// //             </div>
// //           </div>
// //           <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
// //             <span className="text-sm text-gray-500">Consultation Fee</span>
// //             <span className="font-semibold text-indigo-600">₹{expert.price || expert.rate || 0}/session</span>
// //           </div>
// //         </div>

// //         {/* Form */}
// //         <form className="p-6 space-y-4" onSubmit={handleSubmit}>
// //           <div>
// //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// //               <User size={16} />
// //               Full Name
// //             </label>
// //             <input
// //               type="text"
// //               value={fullName}
// //               onChange={(e) => setFullName(e.target.value)}
// //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// //               placeholder="Enter your full name"
// //               required
// //             />
// //           </div>

// //           <div>
// //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// //               <Mail size={16} />
// //               Email Address
// //             </label>
// //             <input
// //               type="email"
// //               value={email}
// //               onChange={(e) => setEmail(e.target.value)}
// //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// //               placeholder="Enter your email"
// //               required
// //             />
// //           </div>

// //           <div>
// //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// //               <Phone size={16} />
// //               Phone Number
// //             </label>
// //             <input
// //               type="tel"
// //               value={phone}
// //               onChange={(e) => setPhone(e.target.value)}
// //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// //               placeholder="Enter your phone number"
// //               required
// //             />
// //           </div>

// //           <div className="grid grid-cols-2 gap-4">
// //             <div>
// //               <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// //                 <Calendar size={16} />
// //                 Date
// //               </label>
// //               <input
// //                 type="date"
// //                 value={bookingDate}
// //                 onChange={(e) => setBookingDate(e.target.value)}
// //                 className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// //                 required
// //               />
// //             </div>
// //             <div>
// //               <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// //                 <Calendar size={16} />
// //                 Time
// //               </label>
// //               <input
// //                 type="time"
// //                 value={bookingTime}
// //                 onChange={(e) => setBookingTime(e.target.value)}
// //                 className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// //                 required
// //               />
// //             </div>
// //           </div>

// //           <div>
// //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// //               <Calendar size={16} />
// //               Duration (minutes)
// //             </label>
// //             <select
// //               value={durationMinutes}
// //               onChange={(e) => setDurationMinutes(parseInt(e.target.value))}
// //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// //             >
// //               <option value={30}>30 minutes</option>
// //               <option value={45}>45 minutes</option>
// //               <option value={60}>60 minutes</option>
// //               <option value={90}>90 minutes</option>
// //               <option value={120}>120 minutes</option>
// //             </select>
// //           </div>

// //           <div>
// //             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
// //               <MessageCircle size={16} />
// //               Message (Optional)
// //             </label>
// //             <textarea
// //               value={message}
// //               onChange={(e) => setMessage(e.target.value)}
// //               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
// //               placeholder="Briefly describe what you need help with..."
// //               rows="3"
// //             />
// //           </div>

// //           <button
// //             type="submit"
// //             disabled={loading}
// //             className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-600 hover:opacity-90 text-white font-semibold py-3 rounded-xl transition disabled:opacity-50"
// //           >
// //             {loading ? (
// //               <>
// //                 <Loader2 className="w-4 h-4 animate-spin" />
// //                 Booking...
// //               </>
// //             ) : (
// //               <>
// //                 <Calendar size={18} />
// //                 Confirm Booking
// //               </>
// //             )}
// //           </button>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // }




// import React, { useState } from 'react';
// import { X, Star, Calendar, User, Mail, Phone, MessageCircle, Loader2 } from 'lucide-react';
// import { useToast } from '../../../../context/ToastContext';
// import bookingService from '../../../service/bookingService';

// // Load Razorpay script
// const loadRazorpayScript = () => {
//   return new Promise((resolve) => {
//     const script = document.createElement('script');
//     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);
//     document.body.appendChild(script);
//   });
// };

// export default function BookingPopup({ expert, onClose, onSubmit }) {
//   const { showToast } = useToast();
//   const [fullName, setFullName] = useState('');
//   const [email, setEmail] = useState('');
//   const [phone, setPhone] = useState('');
//   const [bookingDate, setBookingDate] = useState('');
//   const [bookingTime, setBookingTime] = useState('');
//   const [durationMinutes, setDurationMinutes] = useState(30);
//   const [message, setMessage] = useState('');
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [error, setError] = useState('');

//   const userId = localStorage.getItem('userId');
//   const consultationFee = expert.price || expert.rate || 0;

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate
//     if (!fullName) {
//       setError("Please enter your full name");
//       return;
//     }
//     if (!email) {
//       setError("Please enter your email");
//       return;
//     }
//     if (!phone) {
//       setError("Please enter your phone number");
//       return;
//     }
//     if (!bookingDate) {
//       setError("Please select a date");
//       return;
//     }
//     if (!bookingTime) {
//       setError("Please select a time");
//       return;
//     }
//     if (!userId) {
//       setError("User not logged in. Please login again.");
//       return;
//     }

//     setError("");
//     setIsProcessing(true);

//     try {
//       // Step 1: Create Razorpay order
//       const orderResponse = await bookingService.createOrder(consultationFee);
//       console.log("Order response:", orderResponse);

//       if (!orderResponse.orderId) {
//         throw new Error("Failed to create order. Please try again.");
//       }

//       // Step 2: Load Razorpay script
//       const scriptLoaded = await loadRazorpayScript();
//       if (!scriptLoaded) {
//         throw new Error("Failed to load payment gateway. Please try again.");
//       }

//       // Step 3: Format time as "HH:MM:SS"
//       const formattedTime = bookingTime ? `${bookingTime}:00` : "00:00:00";

//       // Step 4: Open Razorpay checkout
//       const options = {
//         key: orderResponse.key,
//         amount: orderResponse.amount,
//         currency: orderResponse.currency,
//         name: "APIC ProtoHub",
//         description: `Expert Consultation: ${expert.mentorName || expert.name}`,
//         order_id: orderResponse.orderId,
//         prefill: {
//           name: fullName,
//           email: email,
//           contact: phone,
//         },
//         theme: {
//           color: "#4f46e5",
//         },
//         handler: async function (response) {
//           console.log("Payment successful:", response);

//           // Step 5: Create expert booking after successful payment
//           try {
//             const bookingData = {
//               userId: parseInt(userId),
//               expertId: expert.id || expert.expertId,
//               fullName: fullName,
//               email: email,
//               phone: phone,
//               bookingDate: bookingDate,
//               bookingTime: formattedTime,
//               durationMinutes: durationMinutes,
//               message: message || "",
//               consultationFee: consultationFee,
//               razorpayOrderId: orderResponse.orderId,
//               razorpayPaymentId: response.razorpay_payment_id,
//               razorpaySignature: response.razorpay_signature,
//             };

//             console.log("Creating expert booking with data:", bookingData);
//             await onSubmit(bookingData);
//             onClose();
//           } catch (err) {
//             console.error("Expert booking creation error:", err);
//             showToast("Payment successful but booking failed. Please contact support.", "error");
//           }

//           setIsProcessing(false);
//           onClose();
//         },
//         modal: {
//           ondismiss: function () {
//             setIsProcessing(false);
//             console.log("Payment modal closed");
//           }
//         }
//       };

//       const razorpay = new window.Razorpay(options);
//       razorpay.open();

//     } catch (err) {
//       console.error("Error in booking flow:", err);
//       setError(err.message || "Something went wrong. Please try again.");
//       setIsProcessing(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
//       <div style={{ scrollbarWidth: "none" }} className="relative bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition z-10 bg-white rounded-full p-1 shadow-sm hover:shadow-md"
//         >
//           <X size={22} />
//         </button>

//         {/* Header */}
//         <div className="p-6 border-b border-gray-100">
//           <div className="flex items-center gap-4">
//             <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xl font-bold flex items-center justify-center shrink-0">
//               {expert.mentorName ? expert.mentorName.charAt(0).toUpperCase() : expert.initials}
//             </div>
//             <div>
//               <h3 className="font-bold text-gray-900 text-lg">{expert.mentorName || expert.name}</h3>
//               <p className="text-sm text-gray-500">{expert.expertise || expert.specialty}</p>
//               <div className="flex items-center gap-1 mt-0.5">
//                 <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
//                 <span className="text-sm font-medium text-gray-700">{expert.rating || 0}</span>
//                 <span className="text-xs text-gray-400">({expert.institution || 'Expert'})</span>
//               </div>
//             </div>
//           </div>
//           <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
//             <span className="text-sm text-gray-500">Consultation Fee</span>
//             <span className="font-semibold text-indigo-600">₹{consultationFee}/session</span>
//           </div>
//         </div>
       

//         {/* Error message */}
//         {error && (
//           <div className="mx-6 mt-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
//             {error}
//           </div>
//         )}

//         {/* Form */}
//         <form className="p-6 space-y-4" onSubmit={handleSubmit}>
//           <div>
//             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
//               <User size={16} />
//               Full Name
//             </label>
//             <input
//               type="text"
//               value={fullName}
//               onChange={(e) => setFullName(e.target.value)}
//               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//               placeholder="Enter your full name"
//               required
//             />
//           </div>

//           <div>
//             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
//               <Mail size={16} />
//               Email Address
//             </label>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//               placeholder="Enter your email"
//               required
//             />
//           </div>

//           <div>
//             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
//               <Phone size={16} />
//               Phone Number
//             </label>
//             <input
//               type="tel"
//               value={phone}
//               onChange={(e) => setPhone(e.target.value)}
//               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//               placeholder="Enter your phone number"
//               required
//             />
//           </div>

//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
//                 <Calendar size={16} />
//                 Date
//               </label>
//               <input
//                 type="date"
//                 value={bookingDate}
//                 onChange={(e) => setBookingDate(e.target.value)}
//                 className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//                 required
//               />
//             </div>
//             <div>
//               <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
//                 <Calendar size={16} />
//                 Time
//               </label>
//               <input
//                 type="time"
//                 value={bookingTime}
//                 onChange={(e) => setBookingTime(e.target.value)}
//                 className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//                 required
//               />
//             </div>
//           </div>

//           <div>
//             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
//               <Calendar size={16} />
//               Duration (minutes)
//             </label>
//             <select
//               value={durationMinutes}
//               onChange={(e) => setDurationMinutes(parseInt(e.target.value))}
//               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//             >
//               <option value={30}>30 minutes</option>
//               <option value={45}>45 minutes</option>
//               <option value={60}>60 minutes</option>
//               <option value={90}>90 minutes</option>
//               <option value={120}>120 minutes</option>
//             </select>
//           </div>

//           <div>
//             <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
//               <MessageCircle size={16} />
//               Message (Optional)
//             </label>
//             <textarea
//               value={message}
//               onChange={(e) => setMessage(e.target.value)}
//               className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
//               placeholder="Briefly describe what you need help with..."
//               rows="3"
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={isProcessing}
//             className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-600 hover:opacity-90 text-white font-semibold py-3 rounded-xl transition disabled:opacity-50"
//           >
//             {isProcessing ? (
//               <>
//                 <Loader2 className="w-4 h-4 animate-spin" />
//                 Processing...
//               </>
//             ) : (
//               <>
//                 <Calendar size={18} />
//                 Confirm & Pay ₹{consultationFee}
//               </>
//             )}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }



import React, { useState } from 'react';
import { X, Star, Calendar, User, Mail, Phone, MessageCircle, Loader2 } from 'lucide-react';
import { useToast } from '../../../../context/ToastContext';
import bookingService from '../../../service/bookingService';

// Load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export default function BookingPopup({ expert, onClose, onSubmit }) {
  const { showToast } = useToast();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [bookingDate, setBookingDate] = useState('');
  const [bookingTime, setBookingTime] = useState('');
  const [durationMinutes, setDurationMinutes] = useState(30);
  const [message, setMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');

  const userId = localStorage.getItem('userId');
  const consultationFee = expert.price || expert.rate || 0;
  const totalAmount = consultationFee * (durationMinutes / 30);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!fullName) {
      setError("Please enter your full name");
      return;
    }
    if (!email) {
      setError("Please enter your email");
      return;
    }
    if (!phone) {
      setError("Please enter your phone number");
      return;
    }
    if (!bookingDate) {
      setError("Please select a date");
      return;
    }
    if (!bookingTime) {
      setError("Please select a time");
      return;
    }
    if (!userId) {
      setError("User not logged in. Please login again.");
      return;
    }

    setError("");
    setIsProcessing(true);

    try {
      // Step 1: Create Razorpay order with total amount
      const orderResponse = await bookingService.createOrder(totalAmount);
      console.log("Order response:", orderResponse);

      if (!orderResponse.orderId) {
        throw new Error("Failed to create order. Please try again.");
      }

      // Step 2: Load Razorpay script
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        throw new Error("Failed to load payment gateway. Please try again.");
      }

      // Step 3: Format time as "HH:MM:SS"
      const formattedTime = bookingTime ? `${bookingTime}:00` : "00:00:00";

      // Step 4: Open Razorpay checkout
      const options = {
        key: orderResponse.key,
        amount: orderResponse.amount,
        currency: orderResponse.currency,
        name: "APIC ProtoHub",
        description: `Expert Consultation: ${expert.mentorName || expert.name}`,
        order_id: orderResponse.orderId,
        prefill: {
          name: fullName,
          email: email,
          contact: phone,
        },
        theme: {
          color: "#4f46e5",
        },
        handler: async function (response) {
          console.log("Payment successful:", response);
          
          try {
            const bookingData = {
              userId: parseInt(userId),
              expertId: expert.id || expert.expertId,
              fullName: fullName,
              email: email,
              phone: phone,
              bookingDate: bookingDate,
              bookingTime: formattedTime,
              durationMinutes: durationMinutes,
              message: message || "",
              consultationFee: totalAmount,
              razorpayOrderId: orderResponse.orderId,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpaySignature: response.razorpay_signature,
            };

            console.log("Creating expert booking with data:", bookingData);
            await onSubmit(bookingData);
            onClose();
          } catch (err) {
            console.error("Expert booking creation error:", err);
            showToast("Payment successful but booking failed. Please contact support.", "error");
          }

          setIsProcessing(false);
          onClose();
        },
        modal: {
          ondismiss: function() {
            setIsProcessing(false);
            console.log("Payment modal closed");
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (err) {
      console.error("Error in booking flow:", err);
      setError(err.message || "Something went wrong. Please try again.");
      setIsProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div style={{ scrollbarWidth: "none" }} className="relative bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition z-10 bg-white rounded-full p-1 shadow-sm hover:shadow-md"
        >
          <X size={22} />
        </button>

        {/* Header */}
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xl font-bold flex items-center justify-center shrink-0">
              {expert.mentorName ? expert.mentorName.charAt(0).toUpperCase() : expert.initials}
            </div>
            <div>
              <h3 className="font-bold text-gray-900 text-lg">{expert.mentorName || expert.name}</h3>
              <p className="text-sm text-gray-500">{expert.expertise || expert.specialty}</p>
              <div className="flex items-center gap-1 mt-0.5">
                <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
                <span className="text-sm font-medium text-gray-700">{expert.rating || 0}</span>
                <span className="text-xs text-gray-400">({expert.institution || 'Expert'})</span>
              </div>
            </div>
          </div>
          <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
            <span className="text-sm text-gray-500">Consultation Fee</span>
            <div className="text-right">
              <span className="font-semibold text-indigo-600">₹{consultationFee}/session</span>
              <p className="text-xs text-gray-400">* 1 session = 30 minutes</p>
            </div>
          </div>
        </div>

        {/* Error message */}
        {error && (
          <div className="mx-6 mt-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
            {error}
          </div>
        )}

        {/* Form */}
        <form className="p-6 space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <User size={16} />
              Full Name
            </label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              placeholder="Enter your full name"
              required
            />
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <Mail size={16} />
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              placeholder="Enter your email"
              required
            />
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <Phone size={16} />
              Phone Number
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              placeholder="Enter your phone number"
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
                <Calendar size={16} />
                Date
              </label>
              <input
                type="date"
                value={bookingDate}
                onChange={(e) => setBookingDate(e.target.value)}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
                <Calendar size={16} />
                Time
              </label>
              <input
                type="time"
                value={bookingTime}
                onChange={(e) => setBookingTime(e.target.value)}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                required
              />
            </div>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <Calendar size={16} />
              Duration (minutes)
            </label>
            <select
              value={durationMinutes}
              onChange={(e) => setDurationMinutes(parseInt(e.target.value))}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            >
              <option value={30}>30 minutes  </option>
              <option value={60}>60 minutes </option>
              <option value={90}>90 minutes </option>
              <option value={120}>120 minutes </option>
            </select>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <MessageCircle size={16} />
              Message (Optional)
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
              placeholder="Briefly describe what you need help with..."
              rows="3"
            />
          </div>

          {/* Total Amount Summary */}
          <div className="bg-gray-50 rounded-xl p-4 space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-slate-600">Session Fee</span>
              <span className="font-semibold text-slate-800">₹{consultationFee}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-slate-600">Duration</span>
              <span className="font-semibold text-slate-800">{durationMinutes} minutes ({durationMinutes / 30} session{durationMinutes / 30 > 1 ? 's' : ''})</span>
            </div>
            <div className="flex items-center justify-between text-sm border-t border-slate-200 pt-2">
              <span className="font-semibold text-slate-800">Total Amount</span>
              <span className="text-xl font-bold text-indigo-600">₹{totalAmount.toLocaleString("en-IN")}</span>
            </div>
          </div>

          <button
            type="submit"
            disabled={isProcessing}
            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-600 hover:opacity-90 text-white font-semibold py-3 rounded-xl transition disabled:opacity-50"
          >
            {isProcessing ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Processing...
              </>
            ) : (
              <>
                <Calendar size={18} />
                Confirm & Pay ₹{totalAmount.toLocaleString("en-IN")}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}